@if (authService.user(); as user) {
  <div class="flex justify-center rounded-lg">
    <div
      [formGroup]="form()"
      class="bg-white w-full shadow-md px-6 py-8 md:1/2 md:p-14 flex flex-col relative">
      @if (!simplified()) {
        <button (click)="drawerService.close()"
                class="absolute top-1 right-1 inline-flex rounded-md p-1.5 text-gray-500 hover:text-bleuCaliceo-300 focus:outline-none focus:ring-1 focus:ring-bleuCaliceo-300 focus:ring-offset-2 focus:ring-offset-bleuCaliceo-100"
                type="button">
          <span class="sr-only">Dismiss</span>
          <svg aria-hidden="true" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
            <path
              d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
          </svg>
        </button>
      }
      <div class="grid grid-cols-2 gap-5">
        <div class="col-span-2 flex flex-col gap-4 md:flex-row place-content-between">
          @if (user.shouldUpdateCenter) {
            @if (centerService.center(); as siteCenter) {
              <div class="mb-4 p-4 bg-gray-50 rounded-lg">
                <p class="text-gray-700 font-semibold text-base">
                  {{ 'citySelectionTitle' | translate }} {{ siteCenter.name }}
                </p>
                <p class="text-gray-500 text-sm mt-1">
                  {{ 'citySelectionDescription' | translate }}
                </p>
                @if (simplified()) {
                  <p [innerHTML]="'otherCenterLink' | translate | byPass" class="text-gray-400 text-xs mt-2"></p>
                }
              </div>
            } @else {
              <div appAutoClose="always" class="relative w-full mb-4">
                <button aria-labelledby="centerChoice"
                        class="border border-gray-200 hover:bg-gray-50 py-5 px-4 pr-10 md:px-7 disabled:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
                        type="button">
                  <span class="flex items-center">
                    <div class="w-12">
                      <img alt="{{'caliceoLocation' | translate}}" class="h-9 w-9 flex-shrink-0 m-auto" height="60"
                           ngSrc="assets/icons/gray/location.svg"
                           width="60">
                    </div>
                    <span class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
                      <p class="font-semibold truncate text-base" id="centerChoice">
                        {{ 'centerSelectionQuestion' | translate }}
                      </p>
                      {{ centerService.withErpId(form().get('centerErpId')?.value ?? -1)?.name }}
                    </span>
                  </span>
                  <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
                    <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
                  </span>
                </button>
                <ul
                  class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                  role="listbox" tabindex="-1">
                  @for (center of activeCenters(); track center.id) {
                    <li (click)="form().get('centerErpId')?.setValue(center.erpId)"
                        (keyup.enter)="emulateClick($event)"
                        [attr.aria-selected]="form().get('centerErpId')?.value === center.erpId"
                        class="text-gray-900 hover:bg-gray-100 relative select-none py-4 px-3 md:px-5 cursor-pointer"
                        role="option"
                        tabindex="0">
                      <div class="flex items-center">
                        <span
                          [ngClass]="form().get('centerErpId')?.value === center.erpId ? 'font-semibold' : 'font-normal'"
                          class="text-lg text-gray-500 ml-3 block truncate">
                          {{ center.name }} @if (center.city; as city) {
                          - {{ city }}
                        }
                        </span>
                      </div>
                    </li>
                  }
                </ul>
                <p class="text-gray-500 text-sm mt-2">{{ 'centerSelectionDescription' | translate }}</p>
              </div>
            }
          }
          @if (!simplified()) {
            <div class="flex flex-row gap-2 items-center">
              <div class="flex items-center mt-3">
                <input [value]="Gender.Male"
                       class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                       formControlName="gender"
                       id="gender-male"
                       name="gender"
                       type="radio">
                <label class="ms-2 text-md font-medium text-gray-500"
                       for="gender-male">{{ 'mister' | translate }}</label>
              </div>
              <div class="flex items-center mt-3">
                <input [value]="Gender.Female"
                       class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                       formControlName="gender"
                       id="gender-female"
                       name="gender"
                       type="radio">
                <label class="ms-2 text-md font-medium text-gray-500"
                       for="gender-female">{{ 'mrs' | translate }}</label>
              </div>
              <div class="flex items-center mt-3">
                <input [value]="Gender.Company"
                       class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                       formControlName="gender"
                       id="gender-company"
                       name="gender"
                       type="radio">
                <label class="ms-2 text-md font-medium text-gray-500"
                       for="gender-company">{{ 'company' | translate }}</label>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="w-full pt-8">
        <div>
          @if (!simplified()) {
            <div class="flex md:flex-row flex-col gap-4 mb-4">
              <div class="w-full md:w-1/2 mb-6 md:mb-0">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="firstName">
                  {{ 'firstName' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white disabled:bg-gray-100"
                  formControlName="firstName"
                  id="firstName"
                  type="text">
              </div>
              <div class="w-full md:w-1/2">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="lastName">
                  {{ 'lastName' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="lastName"
                  id="lastName"
                  type="text">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="birthDate">
                  {{ 'yourBirthday' | translate }} <span class="text-red-600">*</span>
                </label>
                <div class="flex gap-4" id="birthDate">
                  <select autocomplete="bday-day"
                          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                          formControlName="birthDay"
                          id="birthDay"
                          name="birthDay">
                    @for (day of days; track day) {
                      <option
                        [disabled]="!isValidDate(form().get('birthYear')!.value, form().get('birthMonth')!.value, day)"
                        [value]="day">{{ day }}
                      </option>
                    }
                  </select>
                  <select autocomplete="bday-month"
                          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                          formControlName="birthMonth"
                          id="birthMonth"
                          name="birthMonth">
                    @for (month of months; track month) {
                      <option
                        [disabled]="!isValidDate(form().get('birthYear')!.value, month, form().get('birthDay')!.value)"
                        [value]="month">{{ month }}
                      </option>
                    }
                  </select>
                  <select autocomplete="bday-year"
                          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                          formControlName="birthYear"
                          id="birthYear"
                          name="birthYear">
                    @for (year of years; track year) {
                      <option
                        [disabled]="!isValidDate(year, form().get('birthMonth')!.value, form().get('birthDay')!.value)"
                        [value]="year">{{ year }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="address">
                  {{ 'address' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="address"
                  id="address"
                  type="text">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="additionalAddress">
                  {{ 'additionalAddress' | translate }}
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="additionalAddress"
                  id="additionalAddress"
                  type="text">
              </div>
            </div>
            <div class="flex md:flex-row flex-col gap-4 mb-4">
              <div class="w-full md:w-1/2 mb-6 md:mb-0">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="zip">
                  {{ 'zip' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white disabled:bg-gray-100"
                  formControlName="zip"
                  id="zip"
                  type="text">
                @if (displayCities()) {
                  <div class="absolute z-10 flex w-screen max-w-min">
                    <div
                      class="w-56 shrink rounded-xl bg-white p-4 text-sm font-semibold leading-6 text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                      @for (city of cities(); track city) {
                        <button (click)="setCity(city)" class="block p-2 hover:text-bleuCaliceo-400">{{ city }}</button>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="w-full md:w-1/2">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="city">
                  {{ 'city' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  (input)="setCity($any($event.target).value)"
                  [readOnly]="hasCityList()"
                  [value]="form().get('city')?.value"
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 read-only:bg-gray-100"
                  id="city"
                  type="text">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <label class="text-gray-500 text-md font-semibold pb-2 block" for="country">
                {{ 'country' | translate }} <span class="text-red-600">*</span>
              </label>
              <select autocomplete="country"
                      class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                      formControlName="country"
                      id="country"
                      name="country">
                @for (country of sortedCountries(); track country.libelle; ) {
                  <option [value]="country.libelle">{{ country.libelle }}</option>
                }
              </select>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <app-tel-input [allowedCountries]="['BE', 'DE']" formControlName="phone"/>
                @if (form().get('phone')?.errors?.['pattern'] || form().get('phone')?.errors?.['mustBeE164']) {
                  <p class="peer-invalid:visible text-red-600 text-xs mt-2">
                    {{ 'phoneRules' | translate }}
                  </p>
                }
              </div>
            </div>
          }
          <div class="flex flex-col mb-4 text-gray-500">
            <p class="text-base font-semibold pb-2 block">{{ 'communicationPreference' | translate }}</p>
            <p class="text-sm">{{ 'communicationPreferenceMessage' | translate }}</p>
            <div class="flex gap-5 mt-3">
              <div class="flex flex-col gap-2">
                <div class="grid grid-cols-3 gap-4 w-full">
                  <span>{{ 'email' | translate }}</span>
                  <label class="ms-2 text-base font-medium text-gray-500">
                    <input [value]="true"
                           class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                           formControlName="email"
                           id="notification-email-yes"
                           type="radio">
                    {{ 'yes' | translate }}
                  </label>
                  <label class="ms-2 text-base font-medium text-gray-500">
                    <input [value]="false"
                           class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                           formControlName="email"
                           id="notification-email-no"
                           type="radio">
                    {{ 'no' | translate }}
                  </label>
                  <span>{{ 'sms' | translate }}</span>
                  <label class="ms-2 text-base font-medium text-gray-500">
                    <input [value]="true"
                           class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                           formControlName="sms"
                           id="notification-sms-yes"
                           type="radio">
                    {{ 'yes' | translate }}
                  </label>
                  <label class="ms-2 text-base font-medium text-gray-500">
                    <input [value]="false"
                           class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                           formControlName="sms"
                           id="notification-sms-no"
                           type="radio">
                    {{ 'no' | translate }}
                  </label>
                  <span>{{ 'courrier' | translate }}</span>
                  <label class="ms-2 text-base font-medium text-gray-500">
                    <input [value]="true"
                           class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                           formControlName="courrier"
                           id="notification-courrier-yes"
                           type="radio">
                    {{ 'yes' | translate }}
                  </label>
                  <label class="ms-2 text-base font-medium text-gray-500">
                    <input [value]="false"
                           class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                           formControlName="courrier"
                           id="notification-courrier-no"
                           type="radio">
                    {{ 'no' | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button [appProgressClick]="updateProfile"
              [disabled]="form().invalid"
              appHoverGradient
              class="flex items-center gap-3 my-6 w-full justify-center">
        {{ 'save' | translate }}
      </button>
    </div>
  </div>
}
